import React, { useState } from 'react';
import BlackboxPosition from '@catalogo/core-blackbox/position';
import { Observer } from '@catalogo/theme-observer';

const BottomAds = ({ publication, position }) => {
  const [visibility, setVisibility] = useState(false);

  if (!publication) {
    return null;
  }

  return (
    <Observer onceVisible={eventSetVisibility(setVisibility)}>
      <div>{visibility && <BlackboxPosition position={position} publication={publication} />}</div>
    </Observer>
  );
};

export const eventSetVisibility = setVisibility => () => setVisibility(true);

export default BottomAds;
